import moment from "moment"
import React, { useEffect, useState } from "react"
import { Button, CardBody, Col, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import PhoneImageIcon from '../../../assets/images/icon-phone.png';
import IconEdit from '../../../assets/images/icon-edit.png';
import Select from 'react-select';
import IconCalendar from '../../../assets/images/icon/ic_calendar-black.svg';
import { ExaminationForm, ExaminationType } from "../../../constants/nutriconstant"
import CalcUtils from "../../../helpers/CalcUltils"
import { cloneDeep, isEmpty } from "lodash"
import { toast } from "react-toastify"
import ModalPopup from "../../../components/ModalPopup"
import CustomerAdd from "../../customer/CustomerAdd"
import { useHistory } from "react-router"
import NumberFormat from "react-number-format"
import TextUtils from "../../../helpers/TextUtils"
import ToggleButton from "../../../common/ToggleButton"
import { ValueText } from "../ProductAdd"
import { ProductType } from "../ProductList"

const ProductStockFirst = (props: any) => {
    const { data, setData, type, onlyView, stock, setStock, branch, validation, onValidation } = props

    const handleStockAdd = () => {
        const newDetailtiveUser = {
            branch_id: "",
            quantity:"",
            price_cost:"",
        };
        setStock([...stock, newDetailtiveUser]);
    };

    const handleStockUpdate = (dataDetail: any, index: number, name:string) => {
        let newDetailtiveUser = cloneDeep(stock);
        newDetailtiveUser[index] = dataDetail;
        setStock(newDetailtiveUser);
        const stockValidation = {
            ...validation?.stock
        }
        if(!stockValidation[index]) stockValidation[index] = {}
        const item = dataDetail
        stockValidation[index].quantity = stockValidation[index].price_cost = stockValidation[index].branch_id = ''
        if(item?.branch_id && !item?.quantity) stockValidation[index].quantity = 'Tồn đầu không được để trống!'
        if(item?.branch_id && (!item?.price_cost)) stockValidation[index].price_cost = 'Giá vốn không được để trống!'
        if(item?.quantity && (!item?.branch_id)) stockValidation[index].branch_id = 'Chi nhánh không được để trống!'
        if(item?.quantity && (!item?.price_cost)) stockValidation[index].price_cost = 'Giá vốn không được để trống!'
        if(item?.price_cost && (!item?.branch_id)) stockValidation[index].branch_id = 'Chi nhánh không được để trống!'
        if(item?.price_cost && (!item?.quantity)) stockValidation[index].quantity = 'Tồn đầu không được để trống!'
        onValidation({
            ...validation,
            stock: stockValidation
        })
    };

    const handleStockRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(stock);
        newDetailtiveUser.splice(index, 1);
        if(newDetailtiveUser?.length === 0) newDetailtiveUser = [{
            branch_id: "",
            quantity:"",
            price_cost:"",
        }]
        setStock(newDetailtiveUser);
    };
    
    return (
        <PageBody>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div className="nutri-title mb-3">Nhập tồn đầu</div>
                <ToggleButton isDisabled={type == 'view' ? true: false} elmChecked={data?.stock_first_status == 1 ? true : false} data={data} setData={(data:any) => {setData(data)}} name='stock_first_status' />
            </div>
            {data?.stock_first_status == 1 &&
                stock?.map((item:any, index:number) => (
                    <StockItem 
                        detailIndex={index} 
                        data={item}
                        onChangeData={(dataDetail: any, name:string) =>
                            handleStockUpdate(dataDetail, index, name)
                        }
                        branchs={branch}
                        validation={validation && validation.stock && validation.stock[index]}
                        type={type}
                        onlyView={onlyView}
                        handleRemoveData={() => handleStockRemove(index)}
                        handleAddData={() => handleStockAdd()}
                        detail={stock}
                    />
                ))
            }
        </PageBody>
    )
}

const StockItem = (props:any) => {
    const {detailIndex, detail, onChangeData, data, branchs, type, onlyView, handleRemoveData, handleAddData, validation} = props
    
    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        if(name == 'name') {
            if(value?.length > 200) return
        }
        onChangeData({
            ...data,
            [name]: value
        },name)
    }
    
    return (
        <Row key={detailIndex}>
            <Col md={5} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Cơ sở</Label>
                    <Select
                        placeholder={(type=='view' && !data?.branch_id) ? "---" : "Chọn cơ sở..."}
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        isDisabled={onlyView}
                        onChange={(val: any) => handleChangeData({ target: { name: 'branch_id', value: val?.value } })}
                        value={branchs?.filter(
                            (option: any) => data?.branch_id == option.value
                        )}
                        options={branchs}
                    ></Select>
                    {validation?.branch_id &&<div className="invalid-feedback d-block" >{validation?.branch_id}</div>}
                </FormGroup>
            </Col>
            <Col md={3} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Tồn đầu</Label>
                    <NumberFormat 
                        onChange={(e: any) => handleChangeData({ target: { name: 'quantity', value: TextUtils.onlyNumber(e.target.value) } })}
                        name={'quantity'} type={'text'} className="form-control" 
                        value={type === 'view' && !data?.quantity ? '---': data?.quantity}
                        placeholder={(type=='view' && !data?.quantity) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                        maxLength={12}
                    />
                    {validation?.quantity &&<div className="invalid-feedback d-block" >{validation?.quantity}</div>}
                </FormGroup>
            </Col>
            <Col md={3} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Giá vốn</Label>
                    <NumberFormat 
                        onChange={(e: any) => handleChangeData({ target: { name: 'price_cost', value: TextUtils.onlyNumber(e.target.value) } })}
                        name={'price_cost'} type={'text'} className="form-control" 
                        value={type === 'view' && !data?.price_cost ? '---': data?.price_cost}
                        placeholder={(type=='view' && !data?.price_cost) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                        maxLength={12}
                    />
                    {validation?.price_cost &&<div className="invalid-feedback d-block" >{validation?.price_cost}</div>}
                </FormGroup>
            </Col>
            {!onlyView &&
            <Col md={1} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label></Label>
                    
                        <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
                    {
                        detail?.length == detailIndex+1 &&
                        <Button onClick={handleAddData} className='nutri-square mt-2' color='success'><i className='uil-plus'></i></Button>
                    }
                </FormGroup>
            </Col>}
        </Row>
    )
}

export default ProductStockFirst